import publicApi from "../api";
import { useQuery } from "@tanstack/vue-query";
import { securityQuestionsKey } from "../queryKeys";

const getSecurityQuestion = async () => {
  const response = await publicApi.get(`/utils/security_questions`);

  return response.data;
};

const useGetSecurityQuestionsQuery = () => {
  return useQuery({
    queryKey: securityQuestionsKey,
    queryFn: () => getSecurityQuestion()
  });
};

export default useGetSecurityQuestionsQuery;
